export default __webpack_public_path__ + "static/media/hero-background.6b2d64ee.png";